import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import Hint from '../../components/Hint/Hint';
import Switch from '../../components/Switch/Switch';
import InputBox from '../../components/InputBox/InputBox';
import SingleSelect from '../../components/SingleSelect/SingleSelect';
import { useMenu } from '../../contexts/MenuContext';
import InfoBox from '../../components/InfoBox/InfoBox';
import withForm from '../withForm';

const Display = ({handleChange}) => {
    const {
        settingData
    } = useMenu();

    return (
        <>
            {/* <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Theme", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose Role", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            {label: 'Default', value: 'default'},
                                            {label: 'YOOtheme (UiKit)', value: 'yootheme'},
                                        ]}
                                        initialValue={settingData?.security?.passkeys?.display_settings?.theme || 'default'}
                                        name="security.passkeys.display_settings.theme"
                                        selected={settingData?.security?.passkeys?.display_settings?.theme}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Choose a frontend theme. All themes, except \"default\", must be activated to function properly.You can add custom themes using a plugin filters.", "ultimate-security")}</p>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             <div className="setting-unit mb-lg border-top border-bottom">
                <div className="title-group py-3">
                    <p className="pl-body text-text">{__("Configure the Passkey login options to be displayed on the frontend for default WordPress and third-party plugins.", "ultimate-security")}</p>
                </div>
            </div> */}


            {/* <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Wordpress Login Form", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Wordpress Login Form", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Passkey Login for default WordPress login.", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("These options will work only if the respective plugins are installed and activated", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.display_settings.wordpress_login_form"
                                    checked={settingData?.security?.passkeys?.display_settings?.wordpress_login_form}
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login for WooCommerce", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Login for WooCommerce", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("The WooCommerce plugin must be installed and activated to work correctly.", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("These options will work only if the respective plugins are installed and activated", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.display_settings.woocommerce_login_form"
                                    checked={settingData?.security?.passkeys?.display_settings?.woocommerce_login_form} 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login for MemberPress", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Login for MemberPress", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Passkey Login for MemberPress login form.", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("The MemberPress plugin must be installed and activated to work correctly.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.display_settings.membership_login_form"
                                    checked={settingData?.security?.passkeys?.display_settings?.membership_login_form} 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login for Easy Digital Downloads", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Login for Easy Digital Downloads", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Passkey Login for Easy Digital Downloads login form.", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("The Easy Digital Downloads plugin must be installed and activated to work correctly.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.display_settings.easy_digital_downloads_login_form"
                                    checked={settingData?.security?.passkeys?.display_settings?.easy_digital_downloads_login_form}
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit mb-lg">
                <InfoBox className="big-infobox" title={__("NOTE", "ultimate-security")} content={__("Use the following shortcodes to embed the passkey login and registration forms on your frontend pages. These shortcodes are typically only necessary if you need to manually embed the forms on custom pages. By default, the login form handles various options automatically, and you may not need to manage it unless you're working with a custom page.", "ultimate-security")} />
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login Short Code", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Use this shortcode to embed the \"Login via Passkey\" login form.", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.passkeys.display_settings.login_shortcode"
                                        placeholder=""
                                        value={settingData?.security?.passkeys?.display_settings?.login_shortcode || '[ultimate_security_passkeys_login_form]'}
                                        handleChange={handleChange}
                                        readOnly
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("This shortcode to embed the \"Login via Passkey\" login button,this allows users to log in using their passkey credentials. If the user is already logged in, the form will not be displayed.", "ultimate-security")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Register Short Code", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Use this shortcode to embed the passkey registration form.", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.passkeys.display_settings.register_shortcode"
                                        placeholder=""
                                        value={settingData?.security?.passkeys?.display_settings?.register_shortcode || '[ultimate_security_passkeys_register_form]'}
                                        handleChange={handleChange}
                                        readOnly
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("This shortcode to embed the passkey registration form. This allows logged-in users to create and manage their passkey credentials.If the user is not logged in, the form will not be displayed.", "ultimate-security")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-input border-top border-bottom mb-lg">
                <div className="title-group py-3">
                    <h5 className="pl-heading-1 fw-600 text-text">{__("Adminarea Options", "ultimate-security")}</h5>
                    <p className="pl-body text-text">{__("Configure the options available in the admin area.", "ultimate-security")}</p>
                </div>
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Display Passkeys in Users List", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Display Passkeys in Users List", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Enable this option to show the passkeys as a column in the users list in the adminarea.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.display_settings.display_passkeys_in_users_list"
                                    checked={settingData?.security?.passkeys?.display_settings?.display_passkeys_in_users_list}
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Display Passkeys in Edit User/Profile", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Display Passkeys in Edit User/Profile", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Enable this option to show the passkeys on the Edit User and Profile page in the adminarea.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.display_settings.display_passkeys_in_users_profile"
                                    checked={settingData?.security?.passkeys?.display_settings?.display_passkeys_in_users_profile}
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default withForm(Display);